import SoftBadge from "@/components/atoms/SoftBadge";
import { useGetPreformatifDiagnosticQuery } from "@/services/companies/courses/preformatifDiagnostic";
import { faFilePdf, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PreformatifDiagnosticSection: FC<{ companyId: string; courseId: string }> = ({ companyId, courseId }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useGetPreformatifDiagnosticQuery([companyId, courseId]);
  if (isLoading) return null;
  return <Card className="mt-3"><Card.Body className="d-flex align-items-center justify-content-between">
    <div><h5 className="mb-1">Diagnostic préformatif entreprise</h5><SoftBadge bg={data?.status === "finalized" ? "success" : data ? "warning" : "secondary"}>{data?.status === "finalized" ? "Finalisé" : data ? "Brouillon" : "Non créé"}</SoftBadge></div>
    <div className="d-flex gap-2"><Button size="sm" variant="primary" onClick={() => navigate(`/companies/${companyId}/courses/${courseId}/preformatif-diagnostic`)}><FontAwesomeIcon icon={data ? faPen : faFilePdf} className="me-1" />{data ? "Ouvrir" : "Créer"}</Button></div>
  </Card.Body></Card>;
};
export default PreformatifDiagnosticSection;
